import { API_URL } from "@/configs";
import { logger } from "@/lib/logger";
import { logOutUser } from "@/slices/auth/authThunk";
import { store } from "@/store";

import { getServiceUrlOrigin, joinServiceUrl } from "./servicePaths";

// header request
const HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

// hard code type api
// mock: mock api 1, mock2: mock api 2, custom: api unknow
//
const API_TYPE = {
  apiurl: "apiurl",
  mock: "mock",
  mock2: "mock2",
  custom: "custom",
  market: "markets"
};
export default function FETCH(type, path, method, headers = {}, body, params = {}) {
  return new Promise(function (resolve, reject) {
    startFetch(type, path, method, headers, body, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
}

function startFetch(type, path, method, headers, body, params) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      return reject({
        message: "requestApiTimeout",
        localizeMessage: "requestApiTimeout"
      });
    }, 30000); //time out in 30s
    const headersApi: Record<string, string> = {};
    let apiString: string | undefined;
    switch (type) {
      case API_TYPE.apiurl:
        apiString = API_URL;
        {
          const origin = getServiceUrlOrigin(apiString);
          if (origin) {
            headersApi.Origin = origin;
          }
        }
        break;
      // case API_TYPE.mock: // mock api type
      //   apiString = API_URL_MOCK;
      //   headersApi["origin"] = API_URL_MOCK;
      //   break;
      // case API_TYPE.mock2: // mock api type
      //   apiString = API_URL_MOCK_2;
      //   headersApi["origin"] = API_URL_MOCK_2;
      //   break;
      // case API_TYPE.market: // mock api type
      //   apiString = API_URL_MOCK_MARKET;
      //   headersApi["origin"] = API_URL_MOCK_MARKET;
      //   break;
      case API_TYPE.custom:
        apiString = "";
        break;
    }
    // convert params object to string begin character "?" and seperate by "&"
    // let paramsString = "";
    // Object.keys(params).map((m, i) => {
    //   paramsString += (i === 0 ? "?" : "&") + m + "=" + params[m].toString();
    // });
    let paramsString = "";
    const paramsKeys = Object.keys(params);

    paramsKeys.map((m, i) => {
      const value = params[m];
      const encodedValue =
        typeof value === "object" ? encodeURIComponent(JSON.stringify(value)) : encodeURIComponent(value.toString());
      paramsString += (i === 0 ? "?" : "&") + m + "=" + encodedValue;
    });

    const fetchURL = joinServiceUrl(apiString, `${path}${paramsString}`);
    const bodyrequest = body || undefined;
    let httpResponseCode = 200;

    fetch(fetchURL, {
      // credentials: 'include',
      method,
      headers: {
        ...HEADERS,
        ...headersApi,
        ...headers
      },
      body: method.toLowerCase() !== "get" ? JSON.stringify(bodyrequest) : undefined
    })
      .then((response) => {
        clearTimeout(timeout);
        if (!response) {
          return false;
        }

        const { status } = response;
        httpResponseCode = status;

        if (httpResponseCode === 204) {
          // 204 return nothing
          return true;
        }

        return response.json();
      })
      .then((responseJson) => {
        if (httpResponseCode > 300) {
          logger.error("HTTP Error Response", {
            url: fetchURL,
            status: httpResponseCode,
            body,
            response: responseJson
          });
        }

        handleResponse({
          responseJson,
          httpResponseCode,
          onFullfill: resolve,
          onReject: reject
        });
      })
      .catch((error) => {
        handleResponse({
          error,
          httpResponseCode,
          onFullfill: resolve,
          onReject: reject
        });
        clearTimeout(timeout);
        reject(error);
      });
  });
}

function handleResponse({
  responseJson,
  httpResponseCode,
  onFullfill = (response) => Promise.resolve(response),
  onReject = (error) => Promise.reject(error)
}: any) {
  const localizeMessage = responseJson?.message;
  switch (httpResponseCode) {
    case 200:
    case 201:
    case 204: {
      //do something
      onFullfill(responseJson);
      break;
    }
    case 400:
      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });

      break;
    case 401:
      logger.info("FETCH: 401 Unauthorized detected, calling logOutUser");
      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });
      store.dispatch(logOutUser({}));
      break;
    case 403: {
      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });
      break;
    }
    case 404: {
      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });
      break;
    }

    case 500: {
      //do something

      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });

      break;
    }

    default: {
      onReject({
        status: httpResponseCode,
        message: responseJson?.message || "",
        localizeMessage: localizeMessage
      });
      break;
    }
  }
}
